<template>
  <button
    v-ripple
    type="button"
    class="menu-item"
    :class="{ 'is-active': isActive ? isActive() : null }"
    :title="title"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <svg class="remix">
      <use :xlink:href="`${remixiconUrl}#ri-${icon}`" />
    </svg>
  </button>
</template>

<script>
import remixiconUrl from 'remixicon/fonts/remixicon.symbol.svg'
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    isActive: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      remixiconUrl,
    }
  },
}
</script>

<style lang="scss" scoped>
.menu-item {
  width: 1.75rem;
  height: 1.75rem;
  color: #0d0d0d;
  border: none;
  background-color: transparent;
  border-radius: 0.4rem;
  padding: 0.25rem;
  /* margin-right: 0.25rem; */

  svg {
    width: 100%;
    height: 100%;
    fill: currentColor;
  }

  &.is-active,
  &:hover {
    color: #fff;
    background-color: #0d0d0d;
  }
}
</style>
